import styled from 'styled-components';
import { media } from '@minecraft.themes';
import { Loading } from '@minecraft.loader';
import { scrollableContainer } from '../shared/styles';

export const DrawerCategoryViewContainer = styled.div<{ $isLoading: boolean }>`
  ${scrollableContainer}
  background-color: ${(props): string => props.theme.colors.accent.ltGrey2};

  ${(props) =>
    props.$isLoading &&
    `
  position: relative;
  `}
`;

export const DrawerCategoryViewEmpty = styled.div`
  font-weight: 500;
  margin-top: 4.625rem;
  text-align: center;
`;

export const DrawerCategoryViewHeader = styled.div`
  align-items: center;
  background-color: ${(props): string => props.theme.colors.primary.white};
  border-bottom: 0.0625rem solid ${(props): string => props.theme.colors.primary.ltGrey1};
  display: none;
  font-weight: 600;
  padding: 0.5rem 0.625rem;
  margin: -1rem -1.5rem 0;
  text-align: center;

  ${media.sm`
    display: flex;
  `}
`;

export const DrawerCategoryViewBody = styled.div<{ $isSearching: boolean }>`
  ${(props) =>
    !props.$isSearching &&
    `
      margin: 1rem 0;
  `}
`;

export const DrawerCategoryViewTitle = styled.span`
  margin: auto;
`;

export const LoaderContainer = styled.div`
  background-color: ${(props): string => props.theme.colors.primary.white};
  display: flex;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 6;
`;

export const Loader = styled(Loading)`
  margin: auto;
`;
